import {  
  Col,
  Row, 
} from 'react-bootstrap'
import {
  React,
 
  SRLWrapper,
  LazyLoadImage,
  Link
} from '../libraries'


export const ChildLightBox = ({ images, grid }) => {
  return (
    <SRLWrapper images={images}>
      <Row>
        {images.map(ele => {
          return (
            <Col lg={grid ? grid : 3} className='mb-4' key={ele + 1}>
              <Link to={ele.thumbnail} data-attribute='SRL'>
                <LazyLoadImage
                  src={ele.src}
                  alt={ele.caption}
                  width='100%'
                  height='200px'
                />
              </Link>
            </Col>
          )
        })}
      </Row>
    </SRLWrapper>
  )
}
